import $ from 'jquery'

$('#expand-form').click(function(){
  $('#form-wrapper').toggleClass('expa')
  $(this).toggleClass('expa')
  if ($('#form-wrapper').hasClass('expa')) {
    $('#form-wrapper').slideDown()
  } else {
    $('#form-wrapper').slideUp()
  }
})

// if (document.URL.indexOf('#contatta-ser')!=-1) {
//   $('#expand-form').click()
// }



// WEBPACK FOOTER //
// ./src/components/contattav2/index.js